import httpbaseURL from '../../../../modules/Inventory/common/axios';
class MaintenanceScheduleMasterServices {
    createdata(doc) {
        return httpbaseURL.httpMSInventoryUrl.post("/MaintenanceScheduleMaster/Create", doc)
    }
    updatedata(doc) {
        return httpbaseURL.httpMSInventoryUrl.post("/MaintenanceScheduleMaster/Update", doc)
    }
    getdata() {
        return httpbaseURL.httpMSInventoryUrl.get("/MaintenanceScheduleMaster/MaintenanceScheduleList")
    }
    getfindonedata(doc) {
        return httpbaseURL.httpMSInventoryUrl.get("/MaintenanceScheduleMaster/Get?id=" + doc)
    }

    deletedata(doc) {
        return httpbaseURL.httpMSInventoryUrl.delete("/MaintenanceScheduleMaster/Delete?id=" + doc)
    }
    active(DelID, Status) {
        debugger;
        return httpbaseURL.httpMSInventoryUrl.put(
            "/MaintenanceScheduleMaster/Active?id=" + DelID + "&Status=" + Status + ""
        );
    }
}
export default new MaintenanceScheduleMasterServices()